import {MainPage} from "../pages/mainPage";
import {CartFirstStep} from "../pages/cart/cartFirstStep";
import {CartSecondStep} from "../pages/cart/cartSecondStep";
import {CartThirdStep} from "../pages/cart/cartThirdStep";
import {ProductPage} from "../pages/productPage";
import {CategoryPage} from "../pages/categoryPage";
import {SearchPage} from "../pages/searchPage";
import {AboutUsPage} from "../pages/aboutUsPage";
import {ClientsPages} from "../pages/clientsPages";
import {PhotobookPage} from "../pages/photobookPage";
import {ContactPage} from "../pages/contactPage";
import {RegistrationPage} from "../pages/registrationPage";
import {LoginPage} from "../pages/loginPage";

/*
* @desc We use the jQuery hasClass to match the pages, so you can add multiple classes to be matched as ex: 'type-index type-blog'
* */
export const PageHandlers = {
    '.type-index': MainPage,
    '.in-kosik': CartFirstStep,
    '.in-cos-de-cumparaturi': CartFirstStep, // ro kosik
    '.in-kosar': CartFirstStep, // hu kosik
    '.in-cart': CartFirstStep, // en kosik
    '.in-krok-1': CartSecondStep,
    '.in-comanda-plata-si-transport': CartSecondStep, // ro kosik-krok-1
    '.in-lepes-1': CartSecondStep, // hu kosik-krok-1
    '.in-step-1': CartSecondStep, // en kosik-krok-1
    '.in-krok-2': CartThirdStep,
    '.in-comanda-informatii-despre-dvs': CartThirdStep, // ro kosik-krok-2
    '.in-lepes-2': CartThirdStep, // hu kosik-krok-2
    '.in-step-2': CartThirdStep, // en kosik-krok-2
    '.type-product': ProductPage,
    '.type-category': CategoryPage,
    '.in-vyhledavani': SearchPage,
    '.in-kereses': SearchPage, // hu vyhledavani
    '.in-cautare': SearchPage, // ro vyhledavani
    '.in-search': SearchPage, // en vyhledavani
    '.in-photobook': PhotobookPage,
    '.in-collections': PhotobookPage, // en photobook
    '.in-contacts': ContactPage,
    '.in-contact': ContactPage,
    '.in-registrace': RegistrationPage,
    '.in-inregistrare': RegistrationPage, // ro registrace
    '.in-regisztracio': RegistrationPage, // hu registrace
    '.in-registration': RegistrationPage, // en registrace
    '.in-login': LoginPage,
    '.in-conectare-client': LoginPage, // ro login
    '.in-bejelentkezes': LoginPage, // hu login
    'load-by-url': {
        '/o-nas/': AboutUsPage,
        '/about-us/': AboutUsPage, // en o-nas
        '/klient/': ClientsPages,
        '/centru-clienti/': ClientsPages, // ro klient
        '/ugyfel/': ClientsPages, // hu klient
        '/client-center/': ClientsPages, // en klient
        '/klient/nastaveni/': ClientsPages,
        '/centru-clienti/configurarea-contului-meu/': ClientsPages, // ro nastaveni
        '/ugyfel/allitas/': ClientsPages, // hu nastaveni
        '/client-center/my-account-settings/': ClientsPages, // en nastaveni
        '/klient/objednavky/': ClientsPages,
        '/centru-clienti/comenzile-mele/': ClientsPages, // ro objednavky
        '/ugyfel/rendelesek/': ClientsPages, // hu objednavky
        '/client-center/my-orders/': ClientsPages, // en objednavky
        '/klient/klient-doklady/': ClientsPages,
        '/centru-clienti/documentele-mele/': ClientsPages, // ro doklady
        '/ugyfel/ugyfel-adatok/': ClientsPages, // hu doklady
        '/client-center/client-documents/': ClientsPages, // en doklady
        '/klient/klient-slevy/': ClientsPages,
        '/centru-clienti/reducerile-mele/': ClientsPages, // ro slevy
        '/ugyfel/ugyfel-kedvezmenyek/': ClientsPages, // hu slevy
        '/client-center/client-discounts/': ClientsPages, // en slevy
        '/klient/klient-hodnoceni/': ClientsPages,
        '/ugyfel/produktbewertung/': ClientsPages, // ro hodnoceni
        '/centru-clienti/evaluare/': ClientsPages, // hu hodnoceni
        '/client-center/client-ratings/': ClientsPages, // en hodnoceni
        '/klient/klient-diskuze/': ClientsPages,
    }
}
